import * as React from 'react';
import { Block, BlockAlign, Check, UserCard } from '@wix/social-groups-common';
import { Text, TYPOGRAPHY } from 'wix-ui-tpa/Text';
import { Button, PRIORITY } from 'wix-ui-tpa/Button';
import styles from './MemberCard.st.css';
import { MEMBER_NAME } from './hooks';

export interface MemberCardProps {
  name: string;
  image: string | React.ReactNode;
  done: boolean;
  actionLabel: string;
  actionDoneLabel: string;
  onActionClick();
  withDivider?: boolean;
}

export const MemberCard = (props: MemberCardProps) => {
  const {
    onActionClick,
    name,
    image,
    done,
    actionDoneLabel,
    actionLabel,
    withDivider,
  } = props;

  function renderAction() {
    const chars = Math.max(actionDoneLabel.length, actionLabel.length);
    if (!done) {
      return (
        <Button
          priority={PRIORITY.primary}
          onClick={onActionClick}
          className={styles.action}
          style={{ minWidth: `${chars + 1}ch` }}
        >
          {actionLabel}
        </Button>
      );
    }
    return (
      <Block align={BlockAlign.center} className={styles.done}>
        <Text typography={TYPOGRAPHY.listText} className={styles.doneLabel}>
          {actionDoneLabel}
        </Text>
        <Check className={styles.check} />
      </Block>
    );
  }

  return (
    <UserCard
      name={name}
      pic={image}
      dataHook={MEMBER_NAME}
      userAction={renderAction()}
      divider={withDivider}
    />
  );
};
